import './camera.css';
import React, { useState, useEffect, useRef } from 'react';
import sex from'../../images/sex.gif'
import flash from'../../images/flash.png'
import swap from'../../images/swap.png'
import jul from'../../images/Julia.jpg'
import loading from'../../images/load.gif'

function Camera({plot, setPlotLine, goNext, goNextOnI, goMenu, gallery, setGallery, prevBckImg}) {
  const [messages, setMessage] = useState([]);
  const [answers, setAnswers] = useState();
  const [margin, setMargin] = useState();
  const [text, setText] = useState();
  const [txt, setTxt] = useState();
  const [time, setTime] = useState();
  const [seconds, setSeconds] = useState(0);
  const [isVideo, setIsVideo] = useState(false);
  const [myAnswers, setMyAnswers] = useState([]);
  const [opacity, setOpacity] = useState(0);
  const [white, setWhite] = useState(1);
  const [imgOpacity, setImgOpacity] = useState(1);
  const [txtOpacity, setTxtOpacity] = useState(1);
  const [mainImg, setMainImg] = useState();
  const [mainImg2, setMainImg2] = useState();
  const [prevImg, setPrevImg] = useState();
  const [notifImg, setNotifImg] = useState();
  const [notifText, setNotifText] = useState();
  const [notifName, setNotifName] = useState();
  const [blckScrn, setBlckScrn] = useState();
  const [messNum, setMessNum] = useState(0);
  const [value, setValue] = useState();
    const [next, setNext] = useState();
    const [nextOnI, setNextOnI] = useState();
    const [index, setIndex] = useState(20);
      const [load, setLoad] = useState(true);
    const notification = useRef();
  let answered, blck=false, newGallery;

  useEffect(() => {
     newGallery = new Map(gallery);
  });

  useEffect(() => {
      if (seconds < 3600 && isVideo) {
        let tim;
        let min = Math.floor(seconds/60);
        let sec = seconds%60;
        setSeconds(prev => prev + 1);
        if(sec<10){
          sec="0"+sec;
        }
        if(min<10){
          min="0"+min;
        }
        tim=min+":"+sec;
        if(tim === "00:00"){
          setTime("00:00");
        }else{
          setTimeout(setTime, 1000, tim);
        }
      } else {
        setIsVideo(false);
      }
    }, [ time, isVideo ]);

  useEffect(async () => {
    let arrImg=[];
    for(let key in plot){
      if(plot[key].img){
        arrImg.push(plot[key].img);
      }
    }
    if(arrImg.lenght !== 0){
    const proms = await arrImg.map((img) => {
      return new Promise(function (resolve, reject){
        let image = new Image();
        image.src = img;
        image.onload = () => {
        window[img] = image;
        resolve();
    };
      });
    });
        await Promise.all(proms);
        }
        setLoad(false);
        start(messNum);
},[]);

useEffect(() => {
  if(!load){
  setMargin(0-notification.current.clientHeight);
}
},[notification.current]);



function waitin(){
  return new Promise((resolve, reject) => {
    document.getElementById("wrap").onclick=ff;
    document.getElementById("notification").onclick=ff;
async function ff(){
  document.getElementById("wrap").onclick=undefined;
  document.getElementById("notification").onclick=undefined;
  await notif(true);
  resolve();
}
  });
}

function waitinAns(){
  return new Promise((resolve, reject) => {
    document.getElementById("wrap").onclick=ff;
    document.getElementById("notification").onclick=ff;
async function ff(){
  document.getElementById("wrap").onclick=undefined;
  document.getElementById("notification").onclick=undefined;
  resolve();
}
  });
}


function timeZero(){
  return new Promise((resolve, reject) => {
    setTimeout(f, 333);
    function f(){
      resolve();
      return;
    }
  });
}

async function start(startingFrom){
  for(let i=startingFrom;i<plot.length;i++){
    if(plot[i].answered){
      if(answered.indexOf("/static/media/") !==-1){
      answered = answered.split("/static/media/")[1];
      }
      if(plot[i].answered.indexOf("/static/media/") !==-1){
      plot[i].answered = plot[i].answered.split("/static/media/")[1];
      }
      if(answered !== plot[i].answered){
        if(plot[i].endofAnswer){
          answered=undefined;
        }
        continue;
      }
      if(plot[i].endofAnswer){
        answered=undefined;
      }
    }
    if(plot[i].blackScrn){
      if(plot[i].blackScrn === "start"){
        if(plot[i].rough === true){
          await changeOnOff(true, setTxtOpacity);
          setTxt(plot[i].txt)
          setBlckScrn(true);
          blck = true;
          setMessNum(i+1);
          setTxtOpacity(1);
          continue;
        }
        if(i > 0){
        setIndex(20);
        await changeWhite();
        }
        setTxt(plot[i].txt)
        setBlckScrn(true);
        blck = true;
        setMessNum(i+1);
        await changeWhite(true);
        setIndex(14);
        await waitinAns();
        continue;
      }else if(plot[i].blackScrn === "end"){
        setIndex(20);
        await changeWhite();
        setBlckScrn(false);
        blck = false;
        setMessNum(i+1);
        if(plot[i-1].resetTimer){
          await timeZero();
        }
        await changeWhite(true);
        setIndex(14);
        continue;
      }
    }
    if(plot[i].img){
      if(plot[i].video){
        if(plot[i].resetTimer){
          setSeconds(0);
        }else{
          setIsVideo(true);
        }
      }
      if(plot[i].offTimer){
        setIsVideo(false);
      }
      if(plot[i].gallery){
        if(gallery.has(plot[i].img)){
          if(gallery.get(plot[i].img) !== "1"){
          newGallery.set(plot[i].img, '1');
          localStorage.setItem('gallery', JSON.stringify(Array.from(newGallery.entries())));
          setGallery(newGallery);
        }
        }
      }
      let prev = document.getElementById("img1"),current, pre = document.getElementById("img1").src;
      if(plot[i].img.indexOf("/static/media/") !==-1){
      current = plot[i].img.split("/static/media/")[1];
      }
      if(prev){
      if(prev.src.indexOf("/static/media/") !==-1){
      prev = prev.src.split("/static/media/")[1];
      }
    }
      if(prev !== current){
        if(i !== 0){
          if(blck){
            if(pre){
              setPrevImg(pre);
            }else{
              setPrevImg(prevBckImg);
            }
            setMainImg(plot[i].img);
          }else if(plot[i].rough === true){
            setMainImg2(plot[i].img);
            await changeOnOff(true, setImgOpacity);
            setPrevImg(pre);
            setMainImg(plot[i].img);
            setImgOpacity(1);
          }else{
      setIndex(20);
      await changeWhite();
      setPrevImg(pre);
      setMainImg(plot[i].img);
      if(plot[i].resetTimer){
        await timeZero();
      }
      await changeWhite(true);
      setIndex(14);
      }
    }else{
      setPrevImg(prevBckImg);
      setMainImg(plot[i].img);
      await changeWhite(true);
    }
    }
      setMessNum(i+1);
      continue;
    }
    if(plot[i].failedGame){
      localStorage.setItem('plotLine', plot[i].failedGame.value);
      setPlotLine(plot[i].failedGame.value);
    }

setNotifImg(plot[i].photo);
setNotifName(plot[i].from);
setNotifText(plot[i].text);
await notif();
setMessNum(i+1);
if(plot[i].startAnim){
  await startAnim(plot[i].startAnim);
  await notif(true);
  continue;
}
if(!plot[i].answers && !plot[i].endOfChat){
await waitin();
}
if(plot[i].answers){
  await waitinAns();
  setIndex(14);
  setAnswers(plot[i].answers);
  changeOpacity(false);
  break;
}
if(plot[i].endOfChat){
  await waitinAns();
    setIndex(14);
      if(plot[i].endOfChat.skip){
        setNextOnI({text: plot[i].endOfChat.text});
      }else{
      setNext({text: plot[i].endOfChat.text});
      }

}
if(plot[i].skipAnswers){
  answered=undefined;
}
  }
}

function startAnim(arr){
      return new Promise(async (resolve, reject) => {
          setIndex(16);
        let i=0;
        setTimeout(fff, 1500);
        async function not(i){
            await notif(true);
            setNotifImg(jul);
            setNotifName("Julia");
            setNotifText(arr[i]);
            await notif();
            if(i<arr.length-1){
              i++;
              setTimeout(f, 1500);
            }else{
              setTimeout(res, 1500);
              function res(){
                setIndex(14);
                resolve();
              }
            }
            function f(){
              not(i);
            }
          }
          function fff(){
            not(i);
          }
      });
    }

async function myAnswer(e){
await ans();

  function ans(){
        return new Promise(async (resolve, reject) => {
            setIndex(18);
            changeOpacity(true);
            if(!e.target.src && e.target.innerHTML.indexOf("<img src=") === -1){
            answered=e.target.innerHTML;
          }else{
            if(e.target.src){
              answered="/static" + e.target.src.split("/static")[1];
          }else{
            answered="/static" + e.target.childNodes[0].src.split("/static")[1];
          }
          }
            await notif(true);
            start(messNum);
            resolve();
          });
        }
}

function notif(up){
return new Promise((resolve, reject) => {
 let marginTopDown = window.innerHeight*0.03;
 let marginTopUp = 0-notification.current.clientHeight;
  let minus = 4;
  if(up){
    var mar=2;
    change(up);
  }else{
    var mar=0-notification.current.clientHeight;
    change();
  }
  function change(up){
  if(up){
    if(mar>marginTopUp){
      mar-=4;
    setMargin(mar);
    setTimeout(ChangetoLow, 5);
  }else{
    resolve();
    return;
  }
}else{
  if(mar<marginTopDown){
    if(mar<(marginTopDown-notification.current.clientHeight)/2){
      mar+=minus;
    }else{
      let min = (4-1)/(-1*(marginTopDown-notification.current.clientHeight)/2)
      minus-=min;
        mar+=minus;
    }
  setMargin(mar);
  setTimeout(change, 5);
}else{
  resolve();
  return;
}
}

function ChangetoLow(){
   change(true);
}
}
});
}

async function go(){
  setIndex(20);
  await changeWhite();
  goNext();
}

async function goOnI(){
  setIndex(20);
  await changeWhite();
  setPlotLine(1);
  localStorage.setItem('plotLine', 1);
  goNextOnI(3);
}

async function goToMenu(){
  setIndex(20);
  if(isVideo){
    setIsVideo(false);
  }
  await changeWhite();
  await timeZero();
  goMenu();
}

function changeWhite(toLow){
  return new Promise((resolve, reject) => {
  if(toLow){
    var op=1;
    change(toLow);
  }else{
    var op=0;
    change();
  }
  function change(toLow){
  if(toLow){
    if(op>0){
      op-=0.03;
    setWhite(op);
    setTimeout(ChangetoLow, 10);
  }else{
    resolve();
    setIndex(14);
    return;
  }
}else{
  if(op<1){
    op+=0.03;
  setWhite(op);
  setTimeout(change, 10);
}else{
  resolve();
  return;
}
}

function ChangetoLow(){
   change(true);
}
}
});
}

function changeOpacity(toLow){
  if(toLow){
    var op=1;
    change(toLow);
  }else{
    var op=0;
    change();
  }
  function change(toLow){
  if(toLow){
    if(op>0){
      op-=0.1;
    setOpacity(op);
    setTimeout(ChangetoLow, 20);
  }else{
    setAnswers(undefined);
    return;
  }
}else{
  if(op<1){
    op+=0.1;
  setOpacity(op);
  setTimeout(change, 20);
}else{
  return;
}
}

function ChangetoLow(){
   change(true);
}
}
}

function changeOnOff(toLow, setter){
  return new Promise((resolve, reject) => {
  if(toLow){
    var op=1;
    change(toLow);
  }else{
    var op=0;
    change();
  }
  function change(toLow){
  if(toLow){
    if(op>0){
      op-=0.03;
    setter(op);
    setTimeout(ChangetoLow, 10);
  }else{
    resolve();
    setIndex(14);
    return;
  }
}else{
  if(op<1){
    op+=0.03;
  setter(op);
  setTimeout(change, 10);
}else{
  resolve();
  return;
}
}

function ChangetoLow(){
   change(true);
}
}
});
}

if(load){
return (
  <div className='wr1'><img src={loading} style={{width:"10vw"}}/></div>
);
}

  return (
<div className='wrap'>
{blckScrn && <div className="blckbck"><h1 className='txt' style={{opacity:txtOpacity}}>{txt}</h1></div>}
{next && <div className='nextDay' style={{background:"rgba(0,0,0,0.95)"}} onClick={go}><p>{next.text}</p></div>}
{nextOnI && <div className='nextDay' onClick={goOnI}><p>{nextOnI.text}</p></div>}
<div className='clickWrap' id='wrap' style={{opacity:white,zIndex:index}}></div>
{ answers &&
<div className='answers' style={{opacity:opacity}}>
{answers.map((item,index)=>{
  return (
    <div className='answer' onClick={myAnswer} name={index} key={index}>{item.img? <img src={item.img} height="100px"/> : item}</div>
  )
})}
</div>
}
<div className="notification" id="notification" ref={notification} style={{top:margin+"px"}}>
<div className='pict3'>
  <img className='img' src={notifImg} alt="" />
</div>
<h6 className="nameNot">{notifName}</h6>
<p className="messNot">{notifText}</p>
</div>
<img src={mainImg} id='img1' style={{opacity:imgOpacity}}/>
<img src={mainImg2} id='img22'/>
<div className="cameraTop">
<div className="arrowCam" onClick={goToMenu}>
    <div></div>
</div>
{!blckScrn && <img src={flash}/>}
</div>
{isVideo && <div id="time"><p>{time}</p></div>}
<div className="cameraBottom">
<div className="aboveLine">
<li style={!isVideo? {marginLeft:"13px"} : {marginLeft:"calc(13px + 23.5vw)"}}>
<ul>Pro</ul>
<ul style={isVideo? {color:"#FBD94E"} : {color:"#fff"}}>Video</ul>
<ul style={!isVideo? {color:"#FBD94E"} : {color:"#fff"}}>Photo</ul>
<ul>Portrait</ul>
<ul>More</ul>
</li>
</div>
<div className="underLine">
<div className='pict2'>
  <img className='img1' src={prevImg} alt="" />
</div>
<svg viewBox="0 0 80 80" width="60" height="60">
  <circle className="circle" cx="40" cy="40" r="38"/>
{isVideo && <rect width="30" height="30" x="25" y="26" rx="4" ry="4" style={{fill:"#F32A0B", borderRadius:"5px"}} />}
</svg>
<img className='img2' src={swap} alt="" />
</div>
</div>
</div>
  );
}

export default Camera;
